export const ErrorPage = () => {
  // const error = useRouteError();
  // console.error(error);
  // const msg = error.statusText || error.message;
  return (
    <div id="error-page">
      <h1>404</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      {/* <p>
        <i>{msg}</i>
      </p> */}
    </div>
  );
};
